import clsx from 'clsx';
import * as React from 'react';

import type { CardProps } from '@gitbook/spine-react';

export type InlineCardProps = Pick<CardProps, 'className' | 'children'> & {
    /**
     * Label for A11Y purpose.
     */
    label: string;
};

/**
 * Inline card used to display inline preview and edit form in popovers.
 */
export function InlineCard({
    ref,
    ...props
}: InlineCardProps & { ref?: React.ForwardedRef<HTMLDivElement> }) {
    return (
        <div
            ref={ref}
            {...props}
            className={clsx('w-screen max-w-72 break-words whitespace-pre-wrap', props.className)}
            role="region"
            aria-label={props.label}
        />
    );
}
